import { render } from "./info-background.vue?vue&type=template&id=0044f14f&scoped=true"
import script from "./info-background.vue?vue&type=script&lang=js"
export * from "./info-background.vue?vue&type=script&lang=js"

import "./info-background.vue?vue&type=style&index=0&id=0044f14f&scoped=true&lang=scss"

import exportComponent from "E:\\my-work\\company\\product\\yuanxi\\yuanxi-szty\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0044f14f"]])

export default __exports__